import React from 'react';
import { Card, CardContent, CardHeader, Divider, TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { ISettingsGroups } from '../interfaces';

interface IProps {
  disabled?: boolean;
}

const ApplicationSettings = ({ disabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [CHANGE_EXECUTOR_PERCENT_ERROR],
  } = values.settings[2];

  const field = (index: number) => `settings[2].settings[${index}].value`;

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent>
        <TextField
          type="number"
          variant="filled"
          label={CHANGE_EXECUTOR_PERCENT_ERROR.description}
          value={CHANGE_EXECUTOR_PERCENT_ERROR.value}
          disabled={disabled}
          onChange={(event) => setFieldValue(field(0), event.target.value)}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};

export default ApplicationSettings;
